/** @format */
import plannedTeachingPeriodTpl from './plannedTeachingPeriod.tpl.html';
'use strict';
(function () {
  angular.module('student.timing.plannedTeachingPeriod', ['pascalprecht.translate']).component('plannedTeachingPeriod', {
    bindings: {
      item: '<'
    },
    template: plannedTeachingPeriodTpl
  });
})();